export default function shouldInferEnvFromDomain() {
  return import.meta.env.VITE_APP_INFER_ENV_FROM_DOMAIN === "true";
}
